import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import History from './components/History';
import FAQ from './components/FAQ';
import Fundraising from './components/Fundraising';
import Footer from './components/Footer';
import NotaryNodeMessage from './components/NotaryNodeMessage';
import NotFound from './components/NotFound';

function Home() {
  // Load Feather icons for feature cards
  React.useEffect(() => {
    const loadFeatherIcons = async () => {
      try {
        const feather = await import('feather-icons');
        feather.default.replace();
      } catch (error) {
        console.error('Failed to load Feather icons:', error);
      }
    };
    
    loadFeatherIcons();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Features />
        <History />
        <FAQ />
        <Fundraising />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/notary-nodes" element={<NotaryNodeMessage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
